// DEV-36112: адрес доставки после оплаты — отдельной страницей, как Telegra. Ведёт сюда чекаут
// `/plan/*` (PaywallStepCheckout), отсюда — prescription-review.
const shippingDetailsRoutes = [
	{
		path: '/shipping-details',
		name: 'shipping-details',
		component: () =>
			import(/* webpackChunkName: "shipping-details" */ '@/modules/ShippingDetails/ShippingDetailsView.vue'),
		meta: {
			hideHeader: true,
			skipExperiments: true,
		},
	},
]

export default shippingDetailsRoutes
